
import reports from '../api/reports'

export const state = {
  teacher_reports: [],
  teacher_report_pagination: {},
  student_reports: [],
  student_report_pagination: {},
  teacher_classes: [],
  teacher_classes_total: {},
  teacher_salary: [],
  teacher_salaries: [],
  teacher_salary_pagination: {},
  revenues: [],
  expenses_reports: [],
  teacher_salary_per_id: [],
  revenue_pagination: {},
  expense_report_pagination: {},
  teacher_report_total_hours: 0,
  teacher_report_total_amount: 0,
  total_revenue: 0,
  total_expenses: 0
}

export const getters = {
  teacher_reports: state => state.teacher_reports,
  teacher_report_pagination: state => state.teacher_report_pagination,
  student_reports: state => state.student_reports,
  student_report_pagination: state => state.student_report_pagination,
  teacher_salary_pagination: state => state.teacher_salary_pagination,
  teacher_classes: state => state.teacher_classes,
  teacher_classes_total: state => state.teacher_classes_total,
  teacher_salary: state => state.teacher_salary,
  teacher_salaries: state => state.teacher_salaries,
  revenues: state => state.revenues,
  expenses_reports: state => state.expenses_reports,
  teacher_salary_per_id: state => state.teacher_salary_per_id,
  revenue_pagination: state => state.revenue_pagination,
  expense_report_pagination: state => state.expense_report_pagination,
  teacher_report_total_hours: state => state.teacher_report_total_hours,
  teacher_report_total_amount: state => state.teacher_report_total_amount,
  total_revenue: state => state.total_revenue,
  total_expenses: state => state.total_expenses
}

export const mutations = {
  SET_TEACHER_REPORTS (state, data) {
    state.teacher_reports = data
  },
  SET_TEACHER_PAGINATION (state, data) {
    state.teacher_report_pagination = data
  },
  SET_STUDENT_REPORTS (state, data) {
    state.student_reports = data
  },
  SET_STUDENT_REPORT_PAGINATION (state, data) {
    state.student_report_pagination = data
  },
  SET_TEACHER_CLASSES (state, data) {
    state.teacher_classes = data
  },
  SET_TEACHER_CLASSES_TOTAL (state, data) {
    state.teacher_classes_total = data
  },
  TEACHER_SALARY (state, data) {
    state.teacher_salary.push(data)
  },
  SET_TEACHER_SALARIES (state, data) {
    state.teacher_salaries = data
  },
  SET_TEACHER_SALARY_PAGINATION (state, data) {
    state.teacher_salary_pagination = data
  },
  SET_REVENUE_PAGINATION (state, data) {
    state.revenue_pagination = data
  },
  REVENUE (state, data) {
    state.revenues = data
  },
  EXPENSES (state, data) {
    state.expenses_reports = data
  },
  SET_TEACHER_SALARIES_PER_ID (state, data) {
    state.teacher_salary_per_id = data
  },
  SET_EXPENSE_REPORT_PAGINATION (state, data) {
    state.expense_report_pagination = data
  },
  SET_TEACHER_REPORT_TOTAL_HOURS (state, data) {
    state.teacher_report_total_hours = data
  },
  SET_TEACHER_REPORT_TOTAL_AMOUNT (state, data) {
    state.teacher_report_total_amount = data
  },
  SET_TOTAL_REVENUE (state, data) {
    state.total_revenue = data
  },
  SET_TOTAL_EXPENSES (state, data) {
    state.total_expenses = data
  }
}

export const actions = {
  GET_TEACHER_REPORTS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      reports.getTeacherReport({data}).then(response => {
        commit('SET_TEACHER_REPORTS', response.data.items.data)
        commit('SET_TEACHER_REPORT_TOTAL_HOURS', response.data.total_hours)
        commit('SET_TEACHER_REPORT_TOTAL_AMOUNT', response.data.total_amount)
        let paginationData = {
          from: response.data.items.from,
          to: response.data.items.to,
          total: response.data.items.total,
          last_page: response.data.items.last_page
        }
        commit('SET_TEACHER_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  GET_TEACHER_CLASSES ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      reports.getTeacherSalary(data).then(response => {
        commit('SET_TEACHER_CLASSES', response.data.data)
        let classesTotal = {
          additional_bonus: response.data.additional_bonus,
          pending_bonus: response.data.pending_bonus,
          total_amount_payable: response.data.total_amount_payable,
          class_total: response.data.class_total,
          class_total_display: response.data.class_total_display,
          total_hours: response.data.total_hours,
          date_from: response.data.date_from,
          date_to: response.data.date_to
        }
        commit('SET_TEACHER_CLASSES_TOTAL', classesTotal)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CLEAR_TEACHER_CLASSES ({ commit, getters }) {
    commit('SET_TEACHER_CLASSES', [])
    commit('SET_TEACHER_CLASSES_TOTAL', {})
  },
  GET_TEACHER_SALARY ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      reports.getTeacherSalaries(data).then(response => {
        commit('SET_TEACHER_SALARIES', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_TEACHER_SALARY_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  GET_TEACHER_SALARY_PER_ID ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      reports.getTeacherSalariesPerID(id).then(response => {
        commit('SET_TEACHER_SALARIES_PER_ID', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_TEACHER_SALARY ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      reports.createSalary(data).then(response => {
        commit('TEACHER_SALARY', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_TEACHER_SALARY ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      reports.editTeacherSalary(data.data, data.id).then(response => {
        commit('TEACHER_SALARY', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  GET_STUDENT_REPORTS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      reports.getStudentReport({ data }).then(response => {
        commit('SET_STUDENT_REPORTS', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_STUDENT_REPORT_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  GET_REVENUE ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      reports.getRevenue({data}).then(response => {
        commit('REVENUE', response.data.data)
        commit('SET_TOTAL_REVENUE', response.data.total_revenues)
        let paginationData = {
          from: response.data.data.from,
          to: response.data.data.to,
          total: response.data.data.total,
          last_page: response.data.data.last_page
        }
        commit('SET_REVENUE_PAGINATION', paginationData)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  GET_REPORTS_EXPENSES ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      reports.getExpenses({data}).then(response => {
        commit('EXPENSES', response.data.data)
        commit('SET_TOTAL_EXPENSES', response.data.total_expenses)
        let paginationData = {
          from: response.data.data.from,
          to: response.data.data.to,
          total: response.data.data.total,
          last_page: response.data.data.last_page
        }
        commit('SET_EXPENSE_REPORT_PAGINATION', paginationData)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/reports.js